<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                 <h3 class="card-title">Daftar Satuan</h3>
            </div>  
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card" v-if="$gate.isAdmin1()">
              <div class="card-header">
                 <!--<button type="button" class="btn btn-sm btn-primary" @click="newModal">
                    <i class="fa fa-plus-square"></i>
                    Tambah Satuan
                </button>-->

                <div class="card-tools">
                    <input type="text" v-model="searchTerm"  placeholder="Cari">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!--th>ID</th-->
                      <th role='button' v-on:click="sortRecords('nama')">Nama</th>
                      <!--<th>Action</th>-->
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="satuan in satuans.data" :key="satuan.id">

                      <!--td>{{satuan.id}}</td-->
                      <td class="text-capitalize">{{satuan.nama}}</td>
                      <!--<td>

                        <a href="#" @click="editModal(satuan)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                      </td>-->
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <div class="row">
                        <div class="col-6" style="margin-top:10px;">
                                Menampilkan <select v-model="pageShow" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Baris
                        </div>

                        <div class="col-6">
                            <pagination style="float:right;" :data="satuans" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAdmin1()">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Satuan</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Satuan</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateSatuan() : createSatuan()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama Satuan</label>
                            <input v-model="form.nama" type="text" name="nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }">
                            <has-error :form="form" field="nama"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                searchTerm:'',
                satuans : {},
                form: new Form({
                    id : '',
                    nama: '',
                }),
                sortIndex: 'nama',
                sortDirection: 'asc',
                pageShow:10,
            }
        },
        methods: {
            sortRecords (index) {
               
                this.sortIndex = index;
                if(this.sortDirection == 'asc'){
                   this.sortDirection = 'desc';
                }else if(this.sortDirection == 'desc'){
                   this.sortDirection = 'asc';
                }else{
                   this.sortDirection = 'asc';
                }
                
                this.$Progress.start();
                  
                axios.get('/api/satuan?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.satuans = data.data));

                this.$Progress.finish();
            },    
            changePageRange(){
                //alert(this.pageShow);
                this.$Progress.start();
                  
                  axios.get('/api/satuan?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.satuans = data.data));

                  this.$Progress.finish();
            },
            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/satuan?page=' + page + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.satuans = data.data));

                  //axios.get('/api/satuan?page=' + page).then(({ data }) => (this.satuans = data.data));

                  this.$Progress.finish();
            },
            updateSatuan(){
                this.$Progress.start();
                this.form.put('/api/satuan/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadSatuans();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(satuan){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(satuan);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            loadSatuans(){
                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                if(this.$gate.isAdmin1()){
                    axios.get("/api/satuan?search=" + param + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.satuans = data.data));
                }
            },
            
            createSatuan(){

                this.form.post('/api/satuan')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadSatuans();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {

            this.$Progress.start();
            this.loadSatuans();
            this.$Progress.finish();
        },
        watch: {
            searchTerm: function() {
                this.loadSatuans();
            }
        }
    }
</script>